import { useEffect, useRef } from 'react';
import { useLocation, useDispatch, useHistory } from 'umi';
import { getUrlGameId, objToUrl } from '../../utils/url';
import { changeStoreGameInfo } from '../../utils/game';
import { OVERALL_DEFAULT_INFO } from '@op/constants';
import { getLatelyGameList } from '@op/services';
import { DBO_U } from '@op/utils/format';

const whiteList = ['/Preset/', '/gpt/', '/Report/', '/Insights'];
export default function useUrlLinkUpdate({ gameInfo, listMenu }: any) {
  const locationHook: any = useLocation();
  const dispatch = useDispatch();
  const setGameInfoToUrl = (
    edition_unified_id: string = gameInfo.edition_unified_id,
  ) => {
    const { pathname, search } = locationHook;
    const query = DBO_U.queryObj(search) || {};
    if (whiteList.some((item) => pathname.includes(item))) {
      return;
    }
    const newPathname = pathname.endsWith('/')
      ? pathname.substring(0, pathname.length - 1)
      : pathname;
    // TODO: 切换游戏 补上链接v2
    const newUrl = `/v2${newPathname}?${objToUrl({
      gameid: edition_unified_id,
      ...query,
    })}`;
    window.history.replaceState(null, '', newUrl);
  };

  function getDefaultGameInfo() {
    return getLatelyGameList({})
      .then((data: any) => {
        if (data?.length > 0) {
          return data[0].edition_unified_id;
        }
        return OVERALL_DEFAULT_INFO.DEFAULT_GAME_ID;
      })
      .catch(() => {
        return OVERALL_DEFAULT_INFO.DEFAULT_GAME_ID;
      });
  }

  // 限制第二个修改链接方法
  const beginUpdate = useRef(false);
  const setNewGameInfo = async (edition_unified_id?: string) => {
    let realGameId = edition_unified_id;
    if (!realGameId) {
      realGameId = await getDefaultGameInfo();
    }

    setGameInfoToUrl(realGameId);
    // 有相关游戏就切换游戏
    await changeStoreGameInfo(
      { edition_unified_id: realGameId },
      dispatch,
      true,
    );
    beginUpdate.current = false;
  };

  useEffect(() => {
    const { query, hash } = locationHook || {};
    // query.gameid 条件作用：限制为修改url时触发
    // query参数存在，只有在修改url链接和刷新的时候才会有， 切换游戏，切其他菜单的时候都不存在
    // gameInfo.edition_unified_id !== query.gameid 条件作用：去掉刷新的情况，刷新的时候游戏id是相同的
    let urlGameId = query.gameid;
    // 这里的作用还在待定，好像没有什么用
    if (!urlGameId && hash) {
      urlGameId = getUrlGameId(hash);
    }

    if (
      (urlGameId && gameInfo.edition_unified_id !== urlGameId) ||
      listMenu.length === 0
    ) {
      beginUpdate.current = true;
      setNewGameInfo(urlGameId);
    }
  }, [locationHook]);

  useEffect(() => {
    const query = locationHook?.query || {};

    if (gameInfo.edition_unified_id !== query.gameid && !beginUpdate.current) {
      setGameInfoToUrl();
    }
  }, [gameInfo, locationHook]);
}
